export default function shareDropdown() {
    document.querySelectorAll('.share-button').forEach(wrapper => {
        const trigger   = wrapper.querySelector('.wp-block-button__link');
        const dropdown  = wrapper.querySelector('.share-button__dropdown');

        if (!trigger || !dropdown) return;

        trigger.setAttribute('aria-expanded', 'false');
        trigger.setAttribute('aria-haspopup', 'true');

        trigger.addEventListener('click', e => {
            const isOpen = wrapper.classList.toggle('is-open');
            trigger.setAttribute('aria-expanded', String(isOpen));
        });
    });

    // Close on outside click
    document.addEventListener('click', e => {
        document.querySelectorAll('.share-button.is-open').forEach(wrapper => {
            if (!wrapper.contains(e.target)) {
                wrapper.classList.remove('is-open');
                wrapper.querySelector('.wp-block-button__link')?.setAttribute('aria-expanded', 'false');
            }
        });
    });

    // Close on Escape
    document.addEventListener('keydown', e => {
        if (e.key !== 'Escape') return;
        document.querySelectorAll('.share-button.is-open').forEach(wrapper => {
            wrapper.classList.remove('is-open');
            const trigger = wrapper.querySelector('.wp-block-button__link');
            trigger?.setAttribute('aria-expanded', 'false');
            trigger?.focus();
        });
    });
}

shareDropdown();
